// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"942":"20bee975","1205":"ed732275","4035":"dea41333","4202":"bf6d21cb","6470":"7701ddd4"}[chunkId] + ".chunk.css";
};